// extracted by mini-css-extract-plugin
module.exports = {"complete":"KcPosPaymentButton_complete__1vgcl"};